import React, { Fragment } from "react";
import PropTypes from "prop-types";
import VerifiedUser from "@mui/icons-material/VerifiedUser";
import { CollapseCard } from "@totalsoft/rocket-ui";
import memoize from "lodash.memoize";
import ConsentSummary from "./ConsentSummary";
import ConsentList from "./ConsentList";
import { useTranslation } from "react-i18next";
import { useReactiveVar } from "@apollo/client";
import { synchronizationInProgressVar } from "variables";

export const ConsentComponent = ({
  consents,
  partnerId,
  saveConsents,
  consentCardExpanded,
  onConsentCardExpanded,
  onConsentPropertyChange,
  saveDisabled,
  hasWritePermission
}) => {
  const { t } = useTranslation();
  const synchronizationInProgress = useReactiveVar(synchronizationInProgressVar);

  const getAssignedConsents = memoize(consents => {
    return consents ? consents.filter(x => x.selected) : [];
  });

  return (
    <CollapseCard
      id="consentCard"
      icon={VerifiedUser}
      iconColor="primary"
      title={t("Partner.Consents")}
      subheader={<ConsentSummary assignedConsents={getAssignedConsents(consents)} />}
      expanded={consentCardExpanded}
      onToggle={(_, expanded) => onConsentCardExpanded(!expanded)}
      defaultExpanded={synchronizationInProgress}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      {consents && consents.length > 0 ? (
        <ConsentList
          consents={consents}
          partnerId={partnerId}
          saveConsents={saveConsents}
          consentCardExpanded={consentCardExpanded}
          onConsentCardExpanded={onConsentCardExpanded}
          onConsentPropertyChange={onConsentPropertyChange}
          saveDisabled={saveDisabled}
          hasWritePermission={hasWritePermission}
        />
      ) : (
        <></>
      )}
    </CollapseCard>
  );
};
ConsentComponent.propTypes = {
  consents: PropTypes.array,
  partnerId: PropTypes.number,
  saveConsents: PropTypes.func.isRequired,
  consentCardExpanded: PropTypes.bool,
  onConsentCardExpanded: PropTypes.func.isRequired,
  onConsentPropertyChange: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  hasWritePermission: PropTypes.bool.isRequired
};

export default ConsentComponent;
